import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

class Introduce extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <Chip id="50114" type="struct" title="研究院介绍" groupName="财经研究院首页" content={content.content}>
                <div className={styles.introduce}>
                    <img src={content.src} />
                    <div className={styles.wrapper}>
                        <p>{content.descriptionOne}</p>
                        <p>{content.descriptionTwo}</p>
                    </div>
                </div>
            </Chip>
        );
    }
}

/**
 * 定义组件属性类型
 * 类型以及是否需要
 * */
Introduce.propTypes = { content: PropTypes.object };

/**
 * 定义组件默认属性
 * */
Introduce.defaultProps = {};

export default Introduce;
